var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100"},[_c('b-container',{staticClass:"h-100"},[_c('b-row',{staticClass:"h-100 align-items-center justify-content-center"},[_c('b-col',[_c('div',{staticClass:"loader"})])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }